export const ApplicationLink = {
    "请选择应用环节":"请选择应用环节",
    "添加应用环节":"添加应用环节",
    "请输入应用环节":"请输入应用环节",
    "确定要删除应用环节":"确定要删除应用环节",
    "删除后将不可恢复":"删除后将不可恢复",
}